import { render, staticRenderFns } from "./VerifyReset.vue?vue&type=template&id=783bf676&scoped=true&"
import script from "./VerifyReset.vue?vue&type=script&lang=ts&"
export * from "./VerifyReset.vue?vue&type=script&lang=ts&"
import style0 from "./VerifyReset.vue?vue&type=style&index=0&id=783bf676&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783bf676",
  null
  
)

export default component.exports